import { boolean, RequestKind } from '@sb/library/base';
import { DisplayItemCollection, WebhookLogDisplayItem, WebhookLogSearchOptions } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace WebhookLogRoutes {
    export const Get = ApiRoute.Define({
        URL: (webhooklogID: string) => `webhooklogs/${webhooklogID}`,
        Kind: RequestKind.Get,
        ResultType: WebhookLogDisplayItem
    });

    export const GetAll = ApiRoute.Define({
        URL: `webhooklogs`,
        Kind: RequestKind.Get,
        ResultType: DisplayItemCollection<WebhookLogDisplayItem>
    });

    export const Retry = ApiRoute.Define({
        URL: (webhooklogID: string) => `webhooklogs/${webhooklogID}/retry`,
        Kind: RequestKind.Post,
        ResultType: boolean
    });

    export const Search = ApiRoute.Define({
        URL: `search/webhooklogs`,
        Kind: RequestKind.Post,
        PagingAllowed: true,
        BodyType: WebhookLogSearchOptions,
        ResultType: DisplayItemCollection<WebhookLogDisplayItem>
    });
}
